import {
  ensureSecuritySensitiveVerify,
  needsAccountSecurityVerify,
} from '@/utils/securitySensitiveVerify';

/** 路由进入前：修改银行卡相关页面需安全校验 */
export async function accountSecurityBeforeEnter(to, from, next) {
  // 延迟导入 store，避免与 store/index.js 之间产生循环依赖
  const store = (await import('@/store')).default;
  if (!needsAccountSecurityVerify(store)) {
    next();
    return;
  }
  try {
    // await ensureSecuritySensitiveVerify(store);
    next();
  } catch (e) {
    next(false);
  }
}
